module.exports = __webpack_public_path__ + "static/media/rule.906c42cc.svg";